export function isAuthenticated() {
  return localStorage.getItem('isLoggedIn') === 'true';
}
